import {
    ClipboardCheck,
    HeartHandshake,
    MessagesSquare,
    Microscope,
    Shield,
    Sofa,
} from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const ITEMS = [
    {
        icon: HeartHandshake,
        title: "Conforto durante o tratamento",
        desc: "Técnicas e recursos clínicos voltados ao controle do desconforto, de acordo com as necessidades de cada paciente.",
    },
    {
        icon: Microscope,
        title: "Tecnologia avançada",
        desc: "Microscopia operatória, raio-X digital, câmera intraoral e ultrassom auxiliando em cada etapa do atendimento.",
    },
    {
        icon: Sofa,
        title: "Consultório moderno",
        desc: "Ambiente profissional, acolhedor e preparado para o atendimento especializado.",
    },
    {
        icon: ClipboardCheck,
        title: "Eficiência clínica",
        desc: "Planejamento individualizado para definir a abordagem mais adequada a cada caso.",
    },
    {
        icon: Shield,
        title: "Preservação dos dentes naturais",
        desc: "Foco em preservar o dente sempre que houver indicação e possibilidade clínica.",
    },
    {
        icon: MessagesSquare,
        title: "Acompanhamento do paciente",
        desc: "Orientações e suporte após o procedimento, conforme a necessidade de cada tratamento.",
    },
];

export const Differentials = () => (
    <section id="diferenciais" data-testid="differentials-section" className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeader
                overline="Diferenciais"
                title="Tecnologia e cuidado em cada detalhe"
                subtitle="Recursos modernos e atenção individualizada para uma experiência de atendimento mais confortável."
            />
            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {ITEMS.map((item, i) => (
                    <Reveal key={item.title} delay={(i % 3) * 0.1} className="h-full">
                        <article
                            data-testid={`differential-card-${i}`}
                            className="group h-full rounded-3xl border border-slate-200/80 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-[#BFDBFE] hover:shadow-xl hover:shadow-blue-600/5"
                        >
                            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#EFF5FF] text-[#1A6AFF] transition-colors duration-300 group-hover:bg-[#1A6AFF] group-hover:text-white">
                                <item.icon className="h-6 w-6" />
                            </span>
                            <h3 className="mt-6 text-lg font-semibold text-slate-900">{item.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-600">{item.desc}</p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
